import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { logQueries } from '@/services/logsManagement/logsManagement.queries';

export const useAccessLogs = () => {
  const { data, isFetched } = useQuery({
    ...logQueries.access,
  });

  return {
    accessLogs: data?.data || [],
    isFetched,
  };
};
